var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 11",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.049 6.056.326 10.5h.882l3.233-3.858L7.022 10.5H10L6.096 4.665 10 .005h-.882L5.704 4.08 2.978.005H0l4.049 6.051Zm1.208-1.442.396.58L8.8 9.819H7.445l-2.54-3.731-.396-.58L1.208.656h1.355l2.694 3.957Z",
    fill: "#9999AC"
  })));
};
export default SvgX;